import { render } from "./PaymentHistory.vue?vue&type=template&id=09972f6e&scoped=true"
import script from "./PaymentHistory.vue?vue&type=script&lang=js"
export * from "./PaymentHistory.vue?vue&type=script&lang=js"

import "./PaymentHistory.vue?vue&type=style&index=0&id=09972f6e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-09972f6e"

export default script